var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.isDialog,
      callback: function callback($$v) {
        _vm.isDialog = $$v;
      },
      expression: "isDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("views.report.fleet.FleetAnalyticsView.selectionDialog.selectFleets")))]), _c('v-card-text', [_c('fleet-manager-tree', {
    attrs: {
      "partnerId": _vm.partnerId
    },
    model: {
      value: _vm.selectedFleetIds,
      callback: function callback($$v) {
        _vm.selectedFleetIds = $$v;
      },
      expression: "selectedFleetIds"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.isDialog = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("views.report.fleet.FleetAnalyticsView.selectionDialog.cancel")) + " ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": _vm.applySelection
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("views.report.fleet.FleetAnalyticsView.selectionDialog.apply")) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }